// import {debounce} from "./debounce";
// import {Offcanvas} from "bootstrap";
import {parents, trigger} from "./utilities";

/**
 *  Site menu
 */
export class DesktopSiteMenu {
    constructor(navbar) {
        this.navbar = navbar;
        this.mainHeader = this.navbar?.closest('header');
        this.megaDropdownNavLinks = this.navbar?.querySelectorAll('.nav-link.mega-dropdown-trigger');
        this.megaDropdownsWrap = this.mainHeader?.querySelector('.mega-dropdowns');
        this.megaDropdowns = this.mainHeader?.querySelectorAll('.mega-dropdown');
        this.prevNavLink = {};
        this.handleNavLinks();
        this.handleMegaDropdownMedia();
        this.handleMegaDropdownBtnClose();
    }
    scrollToTop() {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "instant",
        });
    }

    deactivateNavLink() {
        this.navbar.querySelector('.nav-link.active')?.classList.remove('active');
    }

    hideMegaDropdown() {
        this.mainHeader.querySelector('.mega-dropdown.show')?.classList.remove('show');
        document.body.classList.remove('scroll-up', 'mega-dropdown-shown');
    }

    setMegaDropdownsByOpacity() {
        this.megaDropdownsWrap.classList.add('mega-dropdowns--by-opacity');
    }

    unsetMegaDropdownsByOpacity() {
        this.megaDropdownsWrap.classList.remove('mega-dropdowns--by-opacity');
    }

    isMegaDropdownShown() {
        return this.mainHeader.querySelector('.mega-dropdown.show') !== null
    }

    handleNavbarTheme() {
        const navbar = this.navbar.closest('.navbar');
        const navbarTheme = navbar?.dataset.theme;
        if (navbarTheme) {
            if (this.isMegaDropdownShown()) {
                navbar.classList.remove('navbar-dark');
            } else {
                navbar.classList.remove('navbar-dark', 'navbar-light')
                navbar.classList.add(navbarTheme);
            }
        }
    }

    /**
     * Determines which dropdown opening animation to use
     */
    handleMegaDropdownAnimation(target) {
        if (
            Object.keys(this.prevNavLink).length === 0
            && this.prevNavLink.constructor === Object
        ) {
            this.prevNavLink = target;
        } else {
            if (this.prevNavLink !== target) {
                this.setMegaDropdownsByOpacity();
                this.prevNavLink = target;
            } else {
                this.unsetMegaDropdownsByOpacity();
            }
        }
    }

    handleNavLinks() {
        if (this.megaDropdownNavLinks.length) {
            this.megaDropdownNavLinks.forEach(navLink => {
                navLink.addEventListener('click', (event) => {
                    event.preventDefault();
                    const target = event.currentTarget;
                    const megaDropdownTarget = target.dataset.megaDropdown;
                    if (!target.classList.contains('active')) {
                        this.hideMegaDropdown();
                        this.deactivateNavLink();
                        target.classList.add('active');
                    } else {
                        this.deactivateNavLink();
                        this.unsetMegaDropdownsByOpacity();
                        this.handleNavbarTheme();
                        this.scrollToTop();
                        this.prevNavLink = {};
                    }
                    this.toggleMegaDropdown(megaDropdownTarget);
                    this.handleMegaDropdownAnimation(target);
                    this.handleNavbarTheme();
                })
            });
        }
    }

    toggleMegaDropdown(target) {
        if (!target) {
            return;
        }
        const megaDropdown = this.mainHeader.querySelector(target);
        if (megaDropdown) {
            megaDropdown.classList.toggle('show');
            document.body.classList.toggle('mega-dropdown-shown');
            setTimeout(() => {
                if (document.body.classList.contains("mega-dropdown-shown")) {
                    document.body.classList.remove('scroll-down');
                }
            });
            if (target === "#dropdown-search" && megaDropdown.classList.contains('show')) {
                const megaDropdownShownEvent = new CustomEvent("megaDropdown.shown", {detail: target});
                document.dispatchEvent(megaDropdownShownEvent);
            }
        }
    }

    handleMegaDropdownBtnClose() {
        if (this.megaDropdowns.length) {
            this.megaDropdowns.forEach(megaDropdown => {
                const btnClose = megaDropdown.querySelector('.btn-close');
                if (btnClose) {
                    btnClose.addEventListener('click', (event) => {
                        event.preventDefault();
                        this.hideMegaDropdown();
                        this.deactivateNavLink();
                        this.unsetMegaDropdownsByOpacity();
                        this.handleNavbarTheme();
                        this.scrollToTop();
                        this.prevNavLink = {};
                    });
                }
            });
        }
    }

    handleMegaDropdownMedia() {
        this.megaDropdowns.forEach(megaDropdown => {
            const megaDropdownMedia = megaDropdown.querySelector('.mega-dropdown__media');
            if (megaDropdownMedia) {
                this.setMegaDropdownMediaWidth(megaDropdownMedia);
                this.onMegaDropdownMediaResize(megaDropdownMedia);
            }
        })
    }

    setMegaDropdownMediaWidth(megaDropdownMedia) {
        if (!megaDropdownMedia) {
            return;
        }
        const mainNav = this.mainHeader.querySelector('#main-nav');
        const navbarPositionRight = mainNav.getBoundingClientRect().right;
        megaDropdownMedia.style.width = `${Number.parseInt(navbarPositionRight, 10)}px`;
    }

    onMegaDropdownMediaResize(megaDropdownMedia) {
        const onResize = debounce((timeout = 100) => this.setMegaDropdownMediaWidth(megaDropdownMedia));
        window.addEventListener("resize", onResize);
    }
}

export class MobileSiteMenu {
    constructor(offcanvas) {
        this.offcanvas = offcanvas;
        this.mainHeader = this.offcanvas.closest('#mainmenu');
        this.btnClose = this.offcanvas.querySelector('.btn-close');
        this.navbarToggler = this.mainHeader.querySelector('#nav-icon3');
        // this.bsOffcanvas = new Offcanvas(this.offcanvas);
        this.navButtons = this.offcanvas.querySelectorAll('.offcanvas-nav__btn');
        this.subNavButtons = this.offcanvas.querySelectorAll('.offcanvas-subNav__btn');
        this.subSubNavButtons = this.offcanvas.querySelectorAll('.offcanvas-subSubNav__btn');
        this.handleNavbarTogglerClick();
        this.handleBtnClose();
        this.handleBackdropClick();
        this.handleNavBtnClick();
        this.handleSubNavBtnClick();
        this.handleSubSubNavBtnClick();
    }

    scrollToTop() {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "instant",
        });
    }

    handleNavbarTogglerClick() {
        this.navbarToggler.addEventListener('click', (e) => {
            // this.bsOffcanvas.toggle();
            // this.offcanvas.querySelector('.offcanvas-body')?.scrollTo(0, 0); // UX
            document.body.classList.add('offcanvas-mobile-shown');
        }, {capture: true});
    }

    hideSubNavShown() {
        this.offcanvas.querySelector('.offcanvas-subNav.show')?.classList.remove('show');
    }

    handleNavBtnClick() {
        if (this.navButtons.length) {
            this.navButtons.forEach(navButton => {
                navButton.addEventListener('click', (e) => {
                    const shouldBeSubNav = e.target.nextElementSibling;
                    if(shouldBeSubNav != null) {
                        e.preventDefault();
                        if (shouldBeSubNav.classList.contains('offcanvas-subNav')) {
                            shouldBeSubNav.classList.toggle('show');
                        }
                    }
                })
            });
        }
    }

    /**
     * Hide opened subNav on subNavButton click
     * @param subNavButton
     * @param subNav
     */
    hideAllSubSubNav (subNavButton, subNav) {
        if (!subNavButton || !subNav) {
            return;
        }
        const subSubNavs = subNav.querySelectorAll('.offcanvas-subSubNav');
        if (subSubNavs.length) {
            subSubNavs.forEach(subSubNav => {
                if (
                    subSubNav.previousSibling.tagName === "BUTTON"
                    && subSubNav.previousSibling.getAttribute('aria-expanded') === "true"
                ) {
                    trigger(subSubNav.previousSibling, 'click');
                }
            });
        }
    }

    handleSubNavBtnClick() {
        if (this.subNavButtons.length) {
            this.subNavButtons.forEach(subNavButton => {
                subNavButton.addEventListener('click', (e) => {
                    e.preventDefault();
                    const subNav = e.currentTarget.parentNode;
                    if (subNav && subNav.classList.contains('offcanvas-subNav')) {
                        subNav.classList.remove('show');
                        this.hideAllSubSubNav(e.currentTarget, subNav);
                    }
                })
            });
        }
    }

    /**
     * Close previous subSubNav opened
     * @param currentSubSubNav
     */
    hideOtherSubSubNav(currentSubSubNav) {
        if (!currentSubSubNav) {
            return
        }
        const currentSubNav = parents(currentSubSubNav, '.offcanvas-subNav')[0];
        const subSubNavs = currentSubNav?.querySelectorAll('.offcanvas-subSubNav');
        this.offcanvas.querySelector('.offcanvas-body')?.scrollTo(0, 0); // UX
        if (subSubNavs.length) {
            subSubNavs.forEach(subSubNav => {
                if (subSubNav !== currentSubSubNav) {
                    if (
                        subSubNav.previousSibling.tagName === "BUTTON"
                        && subSubNav.previousSibling.getAttribute('aria-expanded') === "true"
                    ) {
                        trigger(subSubNav.previousSibling, 'click');
                    }
                }
            })
        }
    }

    handleSubSubNavBtnClick() {
        if (this.subSubNavButtons.length) {
            this.subSubNavButtons.forEach(subSubNavButton => {
                subSubNavButton.addEventListener('click', (e) => {
                    e.preventDefault();
                    const subSubNav = e.target.nextElementSibling;
                    if (subSubNav && subSubNav.classList.contains('offcanvas-subSubNav')) {
                        this.hideOtherSubSubNav(subSubNav);
                    }
                })
            });
        }
    }

    removeOffcanvasMobileShown() {
        document.body.classList.remove('offcanvas-mobile-shown');
        this.hideSubNavShown();
    }

    handleBtnClose() {
        this.btnClose.addEventListener('click', () => {
            this.removeOffcanvasMobileShown();
            this.scrollToTop();
        })
    }

    handleBackdropClick() {
        // Event delegation
        document.body.addEventListener('click', (e) => {
            if (e.target.closest('.offcanvas-backdrop')) {
                this.removeOffcanvasMobileShown();
            }
        })
    }
}
